import React, { useEffect, useState } from "react";
import Header from "../../components/Header.tsx";
import Footer from "../../components/Footer.tsx";
import { Link, useParams, useNavigate } from "react-router-dom";

/**
 * Verify.tsx
 *
 * - Faz GET /api/auth/verify/:token ao montar
 * - Mostra mensagem do backend
 * - Se falhar, permite reenviar usando POST /api/auth/send/token { token }
 */

const Verify = () => {
  const { token } = useParams(); // token vindo da rota /verify/:token
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_API_URL;

  const [verified, setVerified] = useState(false);
  const [message, setMessage] = useState("Verifying...");
  const [verifying, setVerifying] = useState(true);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setMessage("Invalid verification link.");
        setVerified(false);
        setVerifying(false);
        return;
      }

      setVerifying(true);
      try {
        const resp = await fetch(`${baseUrl}/api/auth/verify/${token}`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        // tenta ler body json, mas protege contra corpo vazio / não-json
        let data = null;
        try {
          data = await resp.json();
        } catch (e) {
          data = null;
        }

        if (resp.ok) {
          setVerified(true);
          setMessage(data?.message || "Account verified successfully! Redirecting to login...");
          // redireciona após 3s para login
          setTimeout(() => navigate("/login"), 3000);
        } else {
          setVerified(false);
          setMessage(data?.message || `Verification failed (status ${resp.status}).`);
        }
      } catch (err) {
        console.error("Verification error:", err);
        setVerified(false);
        setMessage("An error occurred while verifying your account.");
      } finally {
        setVerifying(false);
      }
    };

    verify();
  }, [token, baseUrl, navigate]);

  const resendToken = async () => {
    if (!token) {
      alert("Token inválido.");
      return;
    }

    let decodedEmail: string | null = null;

    try {
      decodedEmail = atob(token);
    } catch (e) {
      alert("Token inválido. Não foi possível converter para email.");
      return;
    }

    if (!decodedEmail || !decodedEmail.includes("@")) {
      alert("Email inválido. Faça o cadastro novamente.");
      return;
    }

    setSending(true);

    try {
      const response = await fetch(`${baseUrl}/api/auth/send/token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: decodedEmail })  // <- ESTA É A MUDANÇA
      });

      let data = null;
      try {
        data = await response.json();
      } catch { }

      if (response.ok) {
        alert(data?.message || "Verification email resent successfully!");
      } else {
        alert(data?.message || "Failed to resend email.");
      }

    } catch (error) {
      console.error(error);
      alert("Erro ao reenviar email.");
    } finally {
      setSending(false);
    }
  };


  return (
    <>
      <Header />

      <section className="account padding-top padding-bottom sec-bg-color2">
        <div className="container">
          <div className="account__wrapper">
            <div className="row g-4">
              <div className="col-12">
                <div className="account__content account__content--style1">
                  <div className="account__header">
                    <h2>Account Verification</h2>

                    {verifying ? (
                      <div>
                        <p>Verifying your account, please wait...</p>
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <p style={{ color: verified ? "green" : "red", fontWeight: 500, marginTop: 10 }}>
                        {message}
                      </p>
                    )}
                  </div>

                  <div className="account__divider account__divider--style1">
                    <span></span>
                  </div>

                  {verified ? (
                    <Link className="trk-btn trk-btn--border trk-btn--primary d-block mt-4" to="/login">
                      Go to Login
                    </Link>
                  ) : (
                    <div>
                      <button
                        type="button"
                        className="trk-btn trk-btn--border trk-btn--primary d-block mt-4"
                        onClick={resendToken}
                        disabled={sending}
                      >
                        {sending ? "Sending..." : "Resend Verification Email"}
                      </button>

                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Verify;
